import { sortAscending } from "../../../utility/utility"

const initialState = {
  allWorkqueuesData: [],
  workqueueDataById: {},

  tableLoading: false,
  sidebarLoading: false
};

const WaivesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "GET_ALL_WORKQUEUES_DATA":
      return {
        ...state,
        allWorkqueuesData: sortAscending(payload, "name")
      }
    case "GET_WORKQUEUE_DATA_BY_ID":
      return {
        ...state,
        workqueueDataById: sortAscending(payload, "name")
      }
    case "CLONE_WORKQUEUE_DATA":
    case "ADD_WORKQUEUE_DATA": {
      return {
        ...state,
        allWorkqueuesData: sortAscending(state.allWorkqueuesData.concat(payload), "name")
      }
    }
    case "UPDATE_WORKQUEUE_DATA": {
      return {
        ...state,
        allWorkqueuesData: sortAscending(state.allWorkqueuesData.map((item) => item.id === payload.id ? { ...payload } : item), "name")
      }
    }
    case "DELETE_WORKQUEUE_DATA": {
      return {
        ...state,
        allWorkqueuesData: state.allWorkqueuesData.filter((item) => item.id !== payload)
      }
    }

    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload
      }
    case "SET_SIDEBAR_LOADING":
      return {
        ...state,
        sidebarLoading: payload
      }

    default:
      return state;
  }
};

export default WaivesReducer;
